// extracted by mini-css-extract-plugin
export default {"container":"tr-z","brandName":"ur-z","productName":"vr-z","productNamePdpEnhancements":"wr-z","breakLongProductName":"xr-z"};